import { uniqBy } from 'lodash';
import { ascending } from '../../../../utils/array-utils';
import { EpisodeTitle } from '../types/title';

export function getSeasons(episodes: EpisodeTitle[]) {
  return uniqBy(episodes, (episode) => episode.season.sequenceNumber)
    .map((episode) => episode.season.sequenceNumber)
    .sort(ascending((x) => x));
}

export function bySeason(seasonNum: number | undefined) {
  if (seasonNum === undefined) {
    return () => true;
  }

  return (episode: EpisodeTitle) => {
    return episode.season.sequenceNumber === seasonNum;
  };
}

export function bySource(sourceId: string | string[] | undefined) {
  if (sourceId === undefined) {
    return () => true;
  }

  return (episode: EpisodeTitle) => {
    if (Array.isArray(sourceId)) {
      return sourceId.some((id) => episode.providers.includes(id));
    }

    return episode.providers.includes(sourceId);
  };
}
